// extracted by mini-css-extract-plugin
export default {"list":"NotificationList_list__xbf-7","empty":"NotificationList_empty__kMLKy","emptyIcon":"NotificationList_emptyIcon__2ONW3","emptyText":"NotificationList_emptyText__5vj9Y"};